import './MemberCard.scss';
import { Link, useLocation } from 'react-router-dom';
import createLink from '../../../../../libs/createLink';
import ProfileGenderInfo from '../../../profile/components/ProfileGenderInfo/ProfileGenderInfo';
import { apiCropImage } from '../../../../../config';
import Badge from '../../../../components2/UI/Badge/Badge';
import { isNewMember, isLessThanXDays } from '../../../../../libs/helper';
import Button, { BUTTON_VARIANTS } from '../../../../components2/UI/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import USER_ROLES from '../../../../../const/userRoles';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import useRestriction from '../../../../../hooks/useRestriction';
import CONTENT_RESTRICTION_RULE from '../../../../../const/contentRestrictionRule';
import React from 'react';

const distanceMapper = (distance) => {
    if (!distance) {
        return null;
    }
    if (distance < 5) {
        return `< 5 km`;
    }
    if (distance > 800) {
        return `> 800 km`;
    }
    return `${distance} km`;
}

const shouldShowMessengerButton = (user, currentUser) => {
    const showMessengerButton = 
    !user?.setting?.chatWithOnlyWithFriends 
    || user.isFriend 
    || [USER_ROLES.ADMINISTRATOR, USER_ROLES.MODERATOR].includes(currentUser?.role) 
    || [USER_ROLES.ADMINISTRATOR, USER_ROLES.MODERATOR].includes(user?.role);
    return showMessengerButton;
}

const MemberCard = ({ member, ...props }) => {
    const distanceStr = distanceMapper(member._distance);
    const currentUser = useCurrentUser();
    const location = useLocation();
    const messengerRestriction = useRestriction(CONTENT_RESTRICTION_RULE.MESSENGER, member);
    return (
        <Link {...props} className="member-card" to={createLink('userProfile', member)}>
            <img src={apiCropImage({url: member?.profile?.avatar, height:350, width:250})} alt='avatar'/>
            <div className="member-card-wrapper">
                <div className="member-card-header">
                    <div className='username'>{member.username} <Badge user={member} /></div>
                    <ProfileGenderInfo user={member}/> 

                </div>
                <div className="member-card-info">
                    {distanceStr && <div className="member-card-info-tag">{distanceStr}</div>}
                    {member.online && <div className="member-card-info-tag">En ligne</div>}
                    {isNewMember(member) && <div className="member-card-info-tag">Nouveau</div>}
                    {(!member.online && isLessThanXDays(member.lastActivity, 3)) && <div className="member-card-info-tag">Actif récemment</div>}
                    {member?.setting?.appearInDating && <div className="member-card-info-tag">Rencontre</div>}
                </div>
                {shouldShowMessengerButton(member, currentUser) && (
                    <div className="member-card-actions">
                        <Button 
                            full
                            onClick={messengerRestriction.restrictionHandler}
                            isLink={!messengerRestriction.isRestricted}
                            to={`${createLink("vMessenger")}/${member?._id}`}
                            state={{from:location.pathname}}
                            variant={BUTTON_VARIANTS.CTA_LIGHT}
                            trackingEvent={'messenger_members'}
                            ><FontAwesomeIcon icon={faPaperPlane}/> Écrire</Button>
                    </div>
                )}
            </div>
        </Link>
    );
};

export default React.memo(MemberCard);